import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "sonner";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import ScreenerPage from "@/pages/ScreenerPage";
import StockDetailPage from "@/pages/StockDetailPage";
import WatchlistPage from "@/pages/WatchlistPage";
import SavedScansPage from "@/pages/SavedScansPage";
import SignalsPage from "@/pages/SignalsPage";
import PresetsPage from "@/pages/PresetsPage";
import ComparePage from "@/pages/ComparePage";
import PortfolioPage from "@/pages/PortfolioPage";
import DailySummaryPage from "@/pages/DailySummaryPage";
import BacktestPage from "@/pages/BacktestPage";
import HeatmapPage from "@/pages/HeatmapPage";
import AlertsRulesPage from "@/pages/AlertsRulesPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-base">
        <div className="radar-loader" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: { background: "rgb(var(--bg-panel))", border: "1px solid rgb(var(--bg-border))", color: "rgb(var(--text-primary))" },
            }}
          />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<ScreenerPage />} />
              <Route path="/signals" element={<SignalsPage />} />
              <Route path="/presets" element={<PresetsPage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/daily-summary" element={<DailySummaryPage />} />
              <Route path="/backtest" element={<BacktestPage />} />
              <Route path="/heatmap" element={<HeatmapPage />} />
              <Route path="/alerts-rules" element={<AlertsRulesPage />} />
              <Route path="/watchlist" element={<WatchlistPage />} />
              <Route path="/saved-scans" element={<SavedScansPage />} />
              <Route path="/stock/:symbol" element={<StockDetailPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
